import React,{useState,useEffect} from 'react';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import * as Axios from "../../services/auth";
import { Flip, Slide, toast } from 'react-toastify';

const Login = () => {
	const navigate = useNavigate();
	const [searchParams, setSearchParams] = useSearchParams();
	const [token, setToken] = useState();

	useEffect(async () => {
		if(searchParams.get("token")){
			const url = "accounts/verify-email"
			const val = {
				token: searchParams.get("token"),
			}
			const response = await Axios.commonPost(val, url);	
			if (response && response.status === 200 && response.data.message=="Verification successful, you can now login") {
				toast.success('Verification successful, you can now login.', {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 3000,
					transition: Flip,
				});
				navigate('/');
			}else{
				toast.error('Email Verification Failed !', {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 3000,
					transition: Flip,
				});
				navigate('/');
			}
		}else{
			navigate('/');
		}
	  }, [searchParams])

	return (
		<></>
	);
};

export default Login;